import React, {useEffect, useRef, useState} from 'react';
import DatePicker from 'react-datepicker';
import {
    APPLY,
    MODAL_CANCEL_TEXT,
    FILTER_BUTTON_TEXT,
    CLEAR_ALL_TEXT,
    DATE_HEADER
} from '../utils/constants';
import YuJaButton from './standardization/YuJaButton';
import classes from "./FilterMenu.module.css";
import { ReactComponent as Filter } from "../images/filter.svg";
import { ReactComponent as ARROW_RIGHT } from "../images/arrow_right_black.svg";
import {YuJaCheckbox} from "./standardization/YuJaCheckbox";

export default function FilterMenuNew({ onApply, filterOptions, style={}, isChooser=false, isPPT=false, hasDateRange=true }) {
    const [show, setShow] = useState(false);
    const [optionFilter1, setOptionFilter1] = useState(filterOptions?.optionFilter1);
    const [optionFilter2, setOptionFilter2] = useState(filterOptions?.optionFilter2);
    const [optionFilter3, setOptionFilter3] = useState(filterOptions?.optionFilter3);
    const [dateFilter1, setDateFilter1] = useState(filterOptions?.dateFilter1);
    const [dateFilter2, setDateFilter2] = useState(filterOptions?.dateFilter2);
    const [dateFilterDisplay1, setDateFilterDisplay1] = useState(null);
    const [dateFilterDisplay2, setDateFilterDisplay2] = useState(null);
    const [total, setTotal] = useState(0);

    const dateFilter1Ref = useRef(null);
    const dateFilter2Ref = useRef(null);

    const filterRef = useRef();
    const filterMenuRef = useRef();

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        // console.log(name, value)
        switch (name) {
            case filterOptions?.optionFilter1Name:
                if (optionFilter1.includes(value)) {
                    setOptionFilter1(optionFilter1.filter(option => option !== value));
                } else {
                    setOptionFilter1([...optionFilter1, value]);
                }
                break;
            case filterOptions?.optionFilter2Name:
                if (optionFilter2.includes(value)) {
                    setOptionFilter2(optionFilter2.filter(option => option !== value));
                } else {
                    setOptionFilter2([...optionFilter2, value]);
                }
                break;
            case filterOptions?.optionFilter3Name:
                if (optionFilter3.includes(value)) {
                    setOptionFilter3(optionFilter3.filter(option => option !== value));
                } else {
                    setOptionFilter3([...optionFilter3, value]);
                }
                break;
            // case filterOptions?.dateFilter1Name:
            //     setDateFilter1(value);
            //     break;
            // case filterOptions?.dateFilter2Name:
            //     setDateFilter2(value);
            //     break;
            default:
                console.log('Error: Invalid filter name');
                break;
        }
    };

    const handleCancel = () => {
        setShow(false);
    };

    const handleClear = () => {
        if (filterOptions?.optionFilter1Name) setOptionFilter1([]);
        if (filterOptions?.optionFilter2Name) setOptionFilter2([]);
        if (filterOptions?.optionFilter3Name) setOptionFilter3([]);
        if (filterOptions?.dateFilter1Name) setDateFilter1("");
        if (filterOptions?.dateFilter2Name) setDateFilter2("");
        onApply({
            optionFilter1: [],
            optionFilter2: [],
            optionFilter3: [],
            dateFilter1: "",
            dateFilter2: ""
        });
        setDateFilterDisplay1(null);
        setDateFilterDisplay2(null);
    };

    const handleApply = () => {

        onApply({
            optionFilter1: optionFilter1,
            optionFilter2: optionFilter2,
            optionFilter3: optionFilter3,
            dateFilter1: dateFilter1,
            dateFilter2: dateFilter2
        });
        setShow(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (filterRef.current && !filterRef.current.contains(event.target)) {
                setShow(false);
            }
        }

        if (show) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            setOptionFilter1(filterOptions?.optionFilter1);
            setOptionFilter2(filterOptions?.optionFilter2);
            setOptionFilter3(filterOptions?.optionFilter3);
            setDateFilter1(filterOptions?.dateFilter1);
            setDateFilter2(filterOptions?.dateFilter2);
            if (!filterOptions || !filterOptions.dateFilter1) {
                setDateFilterDisplay1(null);
            }
            if(!filterOptions || !filterOptions.dateFilter2) {
                setDateFilterDisplay2(null);
            }
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [show]);

    useEffect(() => {
        let temp = 0;
        if (!!optionFilter1 && !!filterOptions?.optionsFilter1) {
            temp += optionFilter1.filter(i => filterOptions.optionsFilter1.includes(i)).length;
        }

        if (!!optionFilter2 && !!filterOptions?.optionsFilter2) {
            temp += optionFilter2.filter(i => filterOptions.optionsFilter2.includes(i)).length;
        }

        if (!!optionFilter3 && !!filterOptions?.optionsFilter3) {
            temp += optionFilter3.filter(i => filterOptions.optionsFilter3.includes(i)).length;
        }

        if (!!dateFilter1) {
            temp += 1;
        }

        if (!!dateFilter2) {
            temp += 1;
        }

        setTotal(temp);
    }, [optionFilter1, optionFilter2, optionFilter3, dateFilter1, dateFilter2, filterOptions]);

    const now = new Date();

    return (
        <div style={{position: "relative"}} ref={filterRef}>
            <div className={classes.filterIcon} >
                <Filter
                    tabIndex={0}
                    onMouseDown={e => e.preventDefault()}
                    aria-label={FILTER_BUTTON_TEXT}
                    onClick={() => setShow(!show)}
                    style={{width: 28, height: 28}}
                />

                {!!total &&
                    <span className={classes.filterCounter} onClick={() => setShow(!show)}>{total}</span>
                }
            </div>

            {show &&
                <div
                    ref={filterMenuRef}
                    style={{
                        position: "absolute",
                        top: 50,
                        left: 0,
                        cursor: "default",
                    }}
                >
                    <div className={classes.filterMenu} style={style}>
                        <div className={classes.row} style={{marginBottom: 15}}>
                            <span className={classes.filterCount}>Filter({total})</span>
                            <div style={{flex: 1}}/>
                            <span className={classes.link} onClick={handleClear}>{CLEAR_ALL_TEXT}</span>
                        </div>

                        {/* Option Filter 1 */}
                        {filterOptions?.optionFilter1Name &&
                            <>
                                <div className={classes.row}>
                                    <div className={classes.filterTitle} style={{width: 55}}>
                                        {filterOptions.optionFilter1Name}
                                    </div>
                                    <div className={classes.grid} style={{ rowGap: 10, columnGap: 15, width: "100%"}}>
                                        {filterOptions.optionsFilter1.map((option, index) => (
                                            <YuJaCheckbox
                                                key={index}
                                                id={`optionFilter1-${index}`}
                                                name={filterOptions.optionFilter1Name}
                                                label={option}
                                                size={17}
                                                style={{fontSize: 14, color: "#4D4D4D"}}
                                                onClick={handleInputChange}
                                                value={option}
                                                checked={optionFilter1.includes(option)}
                                                // disabled={optionFilter2 &&
                                                //     ((option === SURVEY && optionFilter2.includes(SCHEDULED))
                                                //         || (option === ATTENDANCE &&
                                                //             (optionFilter2.includes(UNFINISHED)
                                                //                 || optionFilter2.includes(SCHEDULED)
                                                //                 || optionFilter2.includes(SHARED_BY_QUESTION)))
                                                //         || (isPPT && option === MERGED_MODE && optionFilter2.includes(SHARED_ENTIRELY)))
                                                // }
                                            />
                                        ))}
                                    </div>
                                </div>
                            </>

                        }
                        {/* Option Filter 2 */}
                        {filterOptions?.optionFilter2Name &&
                            <>
                                <div className={classes.divider} style={{margin: "20px 0"}}/>
                                <div className={classes.row} style={{alignItems: "start"}}>
                                    <div className={classes.filterTitle} style={{width: 55}}>
                                        {filterOptions.optionFilter2Name}
                                    </div>
                                    <div className={classes.grid} style={{rowGap: 10, columnGap: 15, width: "100%"}}>
                                        {filterOptions.optionsFilter2.map((option, index) => (
                                            <YuJaCheckbox
                                                key={index}
                                                id={`optionFilter2-${index}`}
                                                name={filterOptions.optionFilter2Name}
                                                label={option}
                                                size={17}
                                                style={{fontSize: 14, color: "#4D4D4D"}}
                                                onClick={handleInputChange}
                                                value={option}
                                                checked={optionFilter2.includes(option)}
                                                // disabled={optionFilter1 &&
                                                //     ((option === SCHEDULED && optionFilter1.includes(SURVEY))
                                                //         || (optionFilter1.includes(ATTENDANCE)
                                                //             && (option === UNFINISHED
                                                //                 || option === SHARED_BY_QUESTION
                                                //                 || option === SCHEDULED))
                                                //         || (isPPT && optionFilter1.includes(MERGED_MODE) && option === SHARED_ENTIRELY))
                                                // }
                                            />
                                        ))}
                                    </div>
                                </div>
                            </>

                        }

                        {/* Option Filter 3 */}
                        {filterOptions?.optionFilter3Name &&
                            <>
                                <div className={classes.divider} style={{margin: "20px 0"}}/>
                                <div className={classes.row} style={{alignItems: "start"}}>
                                    <div className={classes.filterTitle} style={{width: 55}}>{filterOptions.optionFilter3Name}</div>
                                    <div className={classes.row} style={{flexWrap: "wrap", rowGap: 5, columnGap: 15}}>
                                        {filterOptions.optionsFilter3.map((option, index) => (
                                            <YuJaCheckbox
                                                key={index}
                                                id={`optionFilter3-${index}`}
                                                name={filterOptions.optionFilter3Name}
                                                label={option}
                                                size={17}
                                                style={{fontSize: 14, color: "#4D4D4D"}}
                                                onClick={handleInputChange}
                                                value={option}
                                                checked={optionFilter3.includes(option)}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </>
                        }

                        {(filterOptions?.dateFilter1Name || filterOptions?.dateFilter1Name) &&
                            <>
                                <div className={classes.divider} style={{margin: "20px 0"}}/>
                                <div className={classes.row} >
                                    <div className={classes.filterTitle} style={{width: 55}}>{DATE_HEADER}</div>
                                    <div className={classes.row}>
                                        {filterOptions?.dateFilter1Name &&
                                            <>
                                                <DatePicker
                                                    enableTabLoop={true}
                                                    // preventOpenOnFocus={true}
                                                    // disabledKeyboardNavigation
                                                    // ref={dateFilter1Ref}
                                                    placeholder='YYYY-MM-DD'
                                                    placeholderText={'YYYY-MM-DD'}
                                                    dateFormat={'yyyy-MM-dd'}
                                                    onChange={value => {
                                                        if (!!value) {
                                                            setDateFilterDisplay1(value);
                                                            setDateFilter1(value.toISOString().split('T')[0]);
                                                        } else {
                                                            setDateFilter1("");
                                                        }
                                                    }}
                                                    style={{fontSize: 20}}
                                                    selected={dateFilterDisplay1}
                                                    shouldCloseOnSelect={true}
                                                    // customInput={<CustomInput/>}
                                                    // customTimeInput={<div style={{height: 11}}> </div>}
                                                    strictParsing={true}
                                                    // minDate={new Date("09-08-2025")}
                                                    // maxDate={now}
                                                    maxDate={dateFilterDisplay2 ? dateFilterDisplay2 : now}
                                                />
                                                <div style={{width: 5}}/>
                                            </>
                                        }

                                        {filterOptions?.dateFilter2Name &&
                                            <>
                                                <ARROW_RIGHT style={{flexShrink: 0}}/>
                                                <div style={{width: 5}}/>

                                                <DatePicker
                                                    enableTabLoop={true}
                                                    // preventOpenOnFocus={true}
                                                    // disabledKeyboardNavigation
                                                    // ref={dateFilter2Ref}
                                                    placeholder='YYYY-MM-DD'
                                                    placeholderText={'YYYY-MM-DD'}
                                                    dateFormat={'yyyy-MM-dd'}
                                                    onChange={value => {
                                                        if (!!value) {
                                                            setDateFilterDisplay2(value);
                                                            setDateFilter2(value.toISOString().split('T')[0]);
                                                        } else {
                                                            setDateFilter2("");
                                                        }
                                                    }}
                                                    selected={dateFilterDisplay2}
                                                    // customInput={<CustomInputEnd />}
                                                    // customTimeInput={<div style={{height: 11}}> </div>}
                                                    shouldCloseOnSelect={true}
                                                    strictParsing={true}
                                                    minDate={dateFilterDisplay1 ? dateFilterDisplay1 : null}
                                                    // maxDate={new Date()}
                                                />
                                            </>
                                        }
                                    </div>
                                </div>
                            </>
                        }

                        <div className="filter-buttons">
                            <YuJaButton type="secondary" style={{fontSize: 13}} onClick={handleCancel}>{MODAL_CANCEL_TEXT}</YuJaButton>
                            <YuJaButton style={{fontSize: 13}} onClick={handleApply}>{APPLY}</YuJaButton>
                        </div>
                    </div>
                </div>


            }
        </div>
    );
}
